import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class BlockerService {

    private counter = 0;
    showBlocker: BehaviorSubject<boolean> = new BehaviorSubject(false);

    increment() {
        this.counter++;
        this.next(true);
    }

    decrement() {
        this.counter--;
        this.next(this.counter !== 0);
    }

    next(value) {
        this.showBlocker.next(value);
    }
}
